import { render, staticRenderFns } from "./average_data.vue?vue&type=template&id=9205ffec&"
import script from "./average_data.vue?vue&type=script&lang=js&"
export * from "./average_data.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports